import React from 'react';
import {
  IconArrowBack,
  IconArrowForward,
  IconButton,
  SingleNumberButton,
} from '@noths/polaris-client-ribbons-design-system';

import { ReviewPagination } from 'src/types/reviews';
import { PAGINATION_NEXT_PAGE, PAGINATION_PREVIOUS_PAGE } from '../constants/copy';
import { getPages } from '../helpers/paginationHelper';
import * as styles from '../styles/ProductReviews.styles';

interface PaginationProps {
  pagination: ReviewPagination;
  loadPageOfReviews: (page: number) => void;
  onProductReviewsNextPage: () => void;
  onProductReviewsPagination: (page: number) => void;
}

export const REVIEWS_PAGINATION_LIST_TESTID = 'REVIEWS_PAGINATION_LIST';

export const Pagination = ({
  pagination: { currentPage, totalPages },
  loadPageOfReviews,
  onProductReviewsNextPage,
  onProductReviewsPagination,
}: PaginationProps) => {
  const pages = getPages(currentPage, totalPages);

  const handlePaginateNextPage = (page: number) => {
    loadPageOfReviews(page);
    onProductReviewsNextPage();
  };

  const handlePageNumberClick = (page: number) => {
    loadPageOfReviews(page);
    onProductReviewsPagination(page);
  };

  return (
    <ul css={styles.paginationList} data-testid={REVIEWS_PAGINATION_LIST_TESTID}>
      <li css={styles.paginationListItem}>
        <IconButton
          Icon={IconArrowBack}
          disabled={currentPage === 1}
          onClick={() => loadPageOfReviews(currentPage - 1)}
          size="small"
          aria-label={PAGINATION_PREVIOUS_PAGE}
        />
      </li>
      {pages.map((page, index) =>
        page !== '...' ? (
          <li key={`pagination-${page}`} css={styles.paginationListItem}>
            <SingleNumberButton
              number={page}
              size="large"
              active={currentPage === page}
              onClick={() => handlePageNumberClick(page)}
              aria-label={`Page ${page}`}
            />
          </li>
        ) : (
          <li key={`pagination-ellipsis-${index + 1}`} css={styles.paginationListItem}>
            {page}
          </li>
        ),
      )}
      <li css={styles.paginationListItem}>
        <IconButton
          Icon={IconArrowForward}
          disabled={currentPage === totalPages}
          onClick={() => handlePaginateNextPage(currentPage + 1)}
          size="small"
          aria-label={PAGINATION_NEXT_PAGE}
        />
      </li>
    </ul>
  );
};
